
import { instantiate } from './7drl-2024-wasm-js.uninstantiated.mjs';
export default (await instantiate()).exports;
